module.exports = __webpack_public_path__ + "img/2.8cf004d2.jpg";